import { useContext } from 'react';

import { WizardContext } from '~/components/authentication/wizard/context';
import { WizardContextType } from '~/components/authentication/wizard/types';

const useWizard = (): WizardContextType => useContext(WizardContext);
export default useWizard;
